import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { motion } from 'framer-motion';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChartSummary = () => {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const years = Array.from(
    { length: currentYear - 2021 },
    (_, i) => currentYear - i
  );

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        padding: 12,
        titleFont: {
          size: 14,
          weight: 'bold',
          family: 'Onest'
        },
        bodyFont: {
          size: 13,
          family: 'Onest'
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 12,
            family: 'Onest'
          },
        },
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 12,
            family: 'Onest'
          },
        },
      },
    },
    barThickness: 15,
    barPercentage: 0.5,
    categoryPercentage: 0.8,
  };

  const mockBackendData = {
    "2024": [
      { month: "Jan", redemptions: 145 },
      { month: "Feb", redemptions: 168 },
      { month: "Mar", redemptions: 132 },
      { month: "Apr", redemptions: 0 },
      { month: "May", redemptions: 0 },
      { month: "Jun", redemptions: 0 },
      { month: "Jul", redemptions: 0 },
      { month: "Aug", redemptions: 0 },
      { month: "Sep", redemptions: 0 },
      { month: "Oct", redemptions: 0 },
      { month: "Nov", redemptions: 0 },
      { month: "Dec", redemptions: 0 }
    ],
    "2023": [
      { month: "Jan", redemptions: 156 },
      { month: "Feb", redemptions: 178 },
      { month: "Mar", redemptions: 189 },
      { month: "Apr", redemptions: 145 },
      { month: "May", redemptions: 167 },
      { month: "Jun", redemptions: 178 },
      { month: "Jul", redemptions: 198 },
      { month: "Aug", redemptions: 167 },
      { month: "Sep", redemptions: 145 },
      { month: "Oct", redemptions: 178 },
      { month: "Nov", redemptions: 189 },
      { month: "Dec", redemptions: 195 }
    ]
  };

  const yearData = mockBackendData[selectedYear] || Array(12).fill({ month: '', redemptions: 0 });
  
  const data = {
    labels: months,
    datasets: [
      {
        label: 'Redemptions',
        data: yearData.map(item => item.redemptions),
        backgroundColor: 'rgba(255, 108, 108, 0.8)',
        borderColor: 'rgba(255, 108, 108, 1)',
        borderWidth: 1,
        borderRadius: 8,
        hoverBackgroundColor: 'rgba(255, 108, 108, 1)',
      }
    ],
  };

  return (
    <motion.div
      className="px-6 py-4 bg-white rounded-lg shadow-md"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="flex justify-between items-center mb-6">
        <h2 className="font-semibold text-md">Redemption Activity</h2>
        <select
          value={selectedYear}
          onChange={(e) => setSelectedYear(Number(e.target.value))}
          className="px-3 py-2 border rounded-md bg-white text-gray-700 text-xs focus:outline-none focus:ring-2 focus:ring-[#FF6C6C]"
        >
          {years.map((year) => (
            <option
              key={year}
              value={year}
              className="hover:bg-[#FF6C6C] hover:text-white"
            >
              {year}
            </option>
          ))}
        </select>
      </div>

      <div className="h-[355px]">
        <Bar data={data} options={options} />
      </div>
    </motion.div>
  );
};

export default BarChartSummary;